import {
	IconAttention,
	IconCheckmarkStrong,
	IconFlag,
	IconTime,
	IconTimetable,
} from '@flixbus/honeycomb-icons-react';

export const getTagAppearanceProp = (status) => {
	switch (status) {
		case 'confirmed':
		case 'inProgress':
			return { appearance: 'success', display: 'subtle' };
		case 'actual':
			return { appearance: 'success' };
		case 'rejected':
		case undefined:
			return { appearance: 'danger', display: 'subtle' };
		default:
			return {};
	}
};

export const statusLabelIconMap = {
	created: {
		icon: IconTime,
		label: 'Created',
	},
	pending: {
		icon: IconTime,
		label: 'Pending',
	},
	planned: {
		icon: IconTimetable,
		label: 'Planned',
	},
	confirmed: {
		icon: IconCheckmarkStrong,
		label: 'Confirmed',
		appearance: 'success',
	},
	rejected: {
		icon: IconAttention,
		label: 'Unassigned',
	},
	actual: {
		icon: IconFlag,
		label: 'Finished',
	},
};
